/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "vuemixApi",
            "endpoint": "https://dt67rnv2oe.execute-api.eu-central-1.amazonaws.com/mix",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:dd8f4e17-7806-4b97-a208-551d3a40ba0c",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_28znDzhLI",
    "aws_user_pools_web_client_id": "40a1ugcratjo11dqmtkkkvh001",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "usercountTable-mix",
            "region": "eu-central-1"
        },
        {
            "tableName": "vuemixTable-mix",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
